module.exports = __webpack_public_path__ + "static/media/girl-at-computer.3f7425b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/girl-at-computer.jpg
// module id = 154
// module chunks = 0